import { client } from "./client";

export async function getIconsByQuery([_tag, query, next_page]: [string, string, string | undefined]) {
  const params: { query: string; next_page?: string } = { query };
  if (next_page) {
    params.next_page = next_page;
  }
  return client.get(`/noun/search`, { params }).then((res) => res.data);
}

export async function getIconsForEmptyState() {
  return client.get(`/noun/defaults`).then((res) => res.data);
}

export async function getSingleIcon(id: string) {
  return client.get(`/noun/${id}/download`).then((res) => res.data);
}

export async function getIconsSuggestions(query: string) {
  return client.get(`/noun/autocomplete?query=${query}`).then((res) => res.data);
}
